// @mui
import { styled, alpha } from '@mui/material/styles';
// utils
import { bgGradient } from '../../utils/cssStyles';
import bgAuth from '../../assets/illustrations/bg-auth.jpg';
import bgAuthDark from '../../assets/illustrations/bg-auth-dark.jpg';

// ----------------------------------------------------------------------

export const StyledRoot = styled('main')(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  backgroundImage: theme.palette.mode === 'light' ? `url(${bgAuth})` : `url(${bgAuthDark})`,
}));

export const StyledSection = styled('div')(({ theme }) => ({
  position: 'relative',
  flexGrow: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  height: '100%',
  minHeight: 'fit-content',
}));

export const StyledSectionBg = styled('div')(({ theme }) => ({
  imgUrl: '/assets/illustrations/bg-auth.jpg',
  top: 0,
  left: 0,
  zIndex: -1,
  width: '100%',
  height: '100%',
  position: 'absolute',
}));

export const StyledContent = styled('div')(({ theme }) => ({
  width: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  justifyContent: 'center',
  padding: theme.spacing(15, 2),
  [theme.breakpoints.up('md')]: {
    flexShrink: 0,
    padding: theme.spacing(30, 8, 0, 8),
  },
}));
